var render = function render(){var _vm=this,_c=_vm._self._c;return _c('text-content',_vm._g({attrs:{"size":'md2',"weight":_vm.weight,"lineHeight":_vm.lineHeight,"decoration":_vm.decoration}},_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }